/*global window,document,theme,WebFont,setInterval,clearInterval,console,jQuery*/
/*eslint no-console: ["off"] */
window.theme = window.theme || {};
document.documentElement.className = document.documentElement.className.replace("no-js", "js");

// var imagesLoaded = require('imagesloaded');
// import lazySizes from 'lazysizes';
var WebFont = require('webfontloader');
import slick from 'slick-carousel';
import featherlight from 'featherlight';
import featherlightGallery from 'featherlight/release/featherlight.gallery.min.js';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

(function($) {
	"use strict";

	theme.init = function() {
		// Initialize infinite scroll FIRST to prevent any layout changes
		theme.initInfiniteScroll();
		
		WebFont.load({
			typekit: {
				id: 'hfr3adq'
			}
		});

		// Mobile menu toggle
		document.querySelector('.menu-toggle')?.addEventListener('click', function() {
			document.documentElement.classList.toggle('menu-open');
			document.querySelector('nav')?.classList.toggle('open');
		});

		// Prevent default on '#' anchors
		document.querySelectorAll('a[href="#"]').forEach(anchor => {
			anchor.addEventListener('click', function(e) {
				e.preventDefault();
			});
		});

		// Sub-menu toggle
		document.querySelectorAll('.menu li.menu-item-has-children > a').forEach(menuItem => {
			menuItem.addEventListener('click', function() {
				const otherMenuItems = document.querySelectorAll('.menu li.menu-item-has-children > a');
				otherMenuItems.forEach(item => {
					if (item !== this) {
						item.classList.remove('open');
						const subMenu = item.nextElementSibling;
						if (subMenu) {
							subMenu.style.display = 'none';
						}
					}
				});
				
				this.classList.toggle('open');
				const subMenu = this.nextElementSibling;
				if (subMenu) {
					subMenu.style.display = subMenu.style.display === 'none' ? 'block' : 'none';
				}
			});
		});

		// Initialize Featherlight Gallery
		const galleryLinks = document.querySelectorAll('.gallery-item a, .pages a');
		if (galleryLinks.length > 0) {
			featherlightGallery(galleryLinks);
		}

		// Animations
		const animateElements = document.querySelectorAll('.animate-on-scroll');
		if (animateElements.length > 0) {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('animate');
					}
				});
			}, {
				threshold: 0.1
			});

			animateElements.forEach(element => {
				observer.observe(element);
			});
		}

		// Smooth scrolling for page navigation
		setTimeout(() => {
			theme.pageNavSmoothScroll();
		}, 100);
		
		// Handle initial hash in URL
		setTimeout(() => {
			theme.handleInitialHash();
		}, 150);
		
		// Handle browser back/forward navigation
		setTimeout(() => {
			theme.handlePopState();
		}, 200);
	}

	theme.pageNavSmoothScroll = function() {
		// Handle page navigation links with smooth scrolling and section offset fix
		document.querySelectorAll('.page-nav-item').forEach(link => {
			link.addEventListener('click', (e) => {
				const href = link.getAttribute('href');
				const match = href.match(/#(section-\d+)/);
				
				if (match) {
					e.preventDefault();
					
					const sectionId = match[1];
					const sectionNumber = parseInt(sectionId.replace('section-', ''));
					
					// Fix off-by-one error: section-4 link should scroll to section-5 element
					const targetSectionId = `section-${sectionNumber + 1}`;
					
					const targetElement = document.getElementById(targetSectionId);
					
					if (targetElement) {
						// Force layout recalculation
						document.body.offsetHeight;
						
						// Get fresh position after forced reflow
						const refreshedTargetTop = targetElement.offsetTop;
						
						// Determine if header is fixed positioned
						const header = document.querySelector('header');
						const headerStyle = window.getComputedStyle(header);
						const isHeaderFixed = headerStyle.position === 'fixed';
						
						// Calculate header offset only if header is fixed
						let headerOffset = 0;
						if (isHeaderFixed) {
							headerOffset = header.offsetHeight;
						}
						
						const scrollToPosition = Math.max(0, refreshedTargetTop - headerOffset);
						
						// Smooth scroll to target position without updating URL
						window.scrollTo({
							top: scrollToPosition,
							behavior: 'smooth'
						});
					} else {
						// If target +1 section doesn't exist, try the original section
						const fallbackElement = document.getElementById(sectionId);
						if (fallbackElement) {
							window.scrollTo({
								top: fallbackElement.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}
				// If it's not a section anchor link, let the browser handle it normally
			});
		});
	};

	theme.handleInitialHash = function() {
		// Check if there's a hash in the URL when page loads
		if (window.location.hash) {
			const anchorId = window.location.hash.substring(1);
			const targetElement = document.getElementById(anchorId);
			
			if (targetElement) {
				// Small delay to ensure page is fully loaded
				setTimeout(() => {
					const header = document.querySelector('header');
					const headerStyle = header ? window.getComputedStyle(header) : null;
					const isHeaderFixed = headerStyle && (headerStyle.position === 'fixed' || headerStyle.position === 'sticky');
					
					let targetPosition = targetElement.offsetTop;
					
					if (isHeaderFixed && header) {
						const headerHeight = header.offsetHeight;
						const extraOffset = 20;
						targetPosition = targetElement.offsetTop - headerHeight - extraOffset;
					}
					
					window.scrollTo({
						top: Math.max(0, targetPosition),
						behavior: 'smooth'
					});
				}, 100);
			}
		}
	};

	theme.handlePopState = function() {
		// Handle browser back/forward navigation
		window.addEventListener('popstate', function(e) {
			if (window.location.hash) {
				const anchorId = window.location.hash.substring(1);
				const targetElement = document.getElementById(anchorId);
				
				if (targetElement) {
					const header = document.querySelector('header');
					const headerStyle = header ? window.getComputedStyle(header) : null;
					const isHeaderFixed = headerStyle && (headerStyle.position === 'fixed' || headerStyle.position === 'sticky');
					
					let targetPosition = targetElement.offsetTop;
					
					if (isHeaderFixed && header) {
						const headerHeight = header.offsetHeight;
						const extraOffset = 20;
						targetPosition = targetElement.offsetTop - headerHeight - extraOffset;
					}
					
					window.scrollTo({
						top: Math.max(0, targetPosition),
						behavior: 'smooth'
					});
				}
			}
		});
	};

	theme.slideshow = function ($container, $obj={}) {
		if (!$container) return;

        let $args = {
            infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			arrows: false,
			fade: true,
			adaptiveHeight: false,
			lazyLoad: 'ondemand',
			lazyLoadBuffer: 1,
            rows: 0, // fix for v1.8.1 
        };

        $args = Object.assign({}, $args, $obj);
		
		$container.slick($args);

		document.querySelectorAll('button.prev').forEach(button => {
			button.addEventListener('click', () => $container.slick('slickPrev'));
		});
		
		document.querySelectorAll('button.next').forEach(button => {
			button.addEventListener('click', () => $container.slick('slickNext'));
		});
	}

	theme.testimonials = function() {
		// 576px, 768px, 992px, 1200px
		$('.testimonial-list').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			rows: 0,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1
					}
				},
			]
		});
	};

	theme.accordion = function($container) {
        var accordionItem = $container.find('.accordion__item'),
            accordionHeading = $container.find('.accordion__heading'),
            accordionText = $container.find('.accordion__text');

        accordionText.hide();
        accordionItem.on('click', function () {
            let thisHeading = $(this).find('.accordion__heading'),
                thisText = $(this).find('.accordion__text'),
                openClass = 'item--open';
            // Expand or collapse this panel
            $(thisText).slideToggle(200);
            $(this).toggleClass(openClass);

            // Hide the other panels
            accordionText.not($(thisText)).slideUp(200);
            accordionItem.not($(this)).removeClass(openClass);
        });
    };

	theme.animations = function() {
        // Horizontal Lock Scroll
        const horzScroll = gsap.timeline();
        const horzScrollEl = document.querySelector(".horz-scroller");
        var wrap = document.querySelector('.scroll__wrapper');
        if( horzScrollEl ) {
            horzScroll.to(".scroll__wrapper", {
                x: -horzScrollEl.scrollWidth + window.innerWidth + "px",
                ease: "none",
            });
            ScrollTrigger.create({
                // pin: true,
                trigger: ".horz-scroller",
                // scroller: "#main",
                start: "top 80%",
                // end: "+=" + (horzScrollEl.scrollWidth - window.innerWidth),
				end: "bottom 20%",
                // scrub: true,
                scrub: 1,
                animation: horzScroll,
            });
			if( horzScroll.scrollTrigger.trigger.classList.contains('color') ) {
				var colorArray = [horzScroll.scrollTrigger.trigger.classList[3], horzScroll.scrollTrigger.trigger.classList[4]];
				horzScroll.scrollTrigger.spacer.classList.add(...colorArray);
			}
        }
	};

	theme.debugSections = function() {
		const sections = document.querySelectorAll('section[id^="section-"]');
		sections.forEach((section, index) => {
			// Section info available for debugging if needed
		});
		
		// Check for duplicate IDs
		const allIds = Array.from(document.querySelectorAll('[id]')).map(el => el.id).filter(id => id.trim() !== '');
		const duplicates = allIds.filter((id, index) => allIds.indexOf(id) !== index);
		if (duplicates.length > 0) {
			duplicates.forEach(dupId => {
				if (dupId && dupId.trim() !== '') {
					const elements = document.querySelectorAll(`#${dupId}`);
					// Duplicate elements found
				}
			});
		}
		
		// Check for all elements with section-4 ID
		const section4Elements = document.querySelectorAll('#section-4');
		// Section-4 elements available for debugging if needed
	};

	theme.initInfiniteScroll = function() {
		const containers = document.querySelectorAll('[data-infinite-scroll]');
		
		containers.forEach(container => {
			const track = container.querySelector('.logos-track');
			if (!track) return;

			// Save original dimensions before any changes
			const originalLogos = Array.from(track.children);
			const containerStyle = window.getComputedStyle(container);
			const originalHeight = container.getBoundingClientRect().height;
			
			// Set container to have fixed dimensions and prevent layout changes
			container.style.height = originalHeight + 'px';
			container.style.overflow = 'hidden';
			container.style.position = 'relative';
			
			// Clone logos for seamless loop
			for (let i = 0; i < 3; i++) {
				originalLogos.forEach(logo => {
					const clone = logo.cloneNode(true);
					track.appendChild(clone);
				});
			}

			let currentX = 0;
			const scrollSpeed = 0.5; // pixels per frame
			const containerWidth = container.offsetWidth;
			const trackWidth = track.scrollWidth;
			const resetPoint = -(trackWidth / 4); // Reset when 1/4 of track has passed

			function animate() {
				currentX -= scrollSpeed;
				
				// Reset position for seamless loop
				if (currentX <= resetPoint) {
					currentX = 0;
				}
				
				track.style.transform = `translateX(${currentX}px)`;
				requestAnimationFrame(animate);
			}

			// Start animation
			animate();

			// Pause on hover
			container.addEventListener('mouseenter', () => {
				track.style.animationPlayState = 'paused';
			});

			container.addEventListener('mouseleave', () => {
				track.style.animationPlayState = 'running';
			});
		});
		
		// Force multiple layout recalculations
		document.body.offsetHeight; // Force reflow
		window.getComputedStyle(document.body).height; // Force style calculation
		
		// Multiple delayed reflows to ensure layout stability
		setTimeout(() => {
			document.body.offsetHeight;
		}, 0);
		
		setTimeout(() => {
			document.body.offsetHeight;
		}, 10);
		
		setTimeout(() => {
			document.body.offsetHeight;
		}, 50);
	};

	// Initialize everything when DOM is ready
	$(function() {
		theme.init();
		
		// Initialize other components
		theme.slideshow($('.slide-list'));
		theme.slideshow($('.product-carousel .images.carousel'), {
			// autoplay: true,
			arrows: true
		});
		theme.accordion($('section.accordion'));
		theme.testimonials();
		
		// GSAP animations last (may also affect layout)
		setTimeout(() => {
			theme.animations();
		}, 50);
		
		// Debug sections after all initialization is complete
		setTimeout(() => {
			theme.debugSections();
		}, 200);
	});
}(jQuery));